function CreateTicket() {
    return (
        <div className="container mt-5">
            <h3>To create a ticket, select a relevant topic</h3>
            <div className="row mt-5">
                <div className="col-4">
                    <h4> <i class="fa-solid fa-circle-plus"></i>Account Opening</h4>
                    <a href="/" className="text-decoration-none lh-lg ">Online Account Opening</a> <br />
                    <a href="/" className="text-decoration-none lh-lg ">Offline Account Opening</a> <br />
                    <a href="/" className="text-decoration-none lh-lg ">Company, Partnership and HUF Account Opening</a> <br />
                    <a href="/" className="text-decoration-none lh-lg ">NRI Account Opening</a> <br />
                    <a href="/" className="text-decoration-none lh-lg ">Charges at Zerodha</a> <br />
                    <a href="/" className="text-decoration-none lh-lg ">Zerodha IDFC FIRST Bank 3-in-1 Account</a> <br />
                    <a href="/" className="text-decoration-none lh-lg ">Getting Started</a> <br />
                </div>
                <div className="col-4">
                    <h4> <i class="fa-solid fa-user"></i> Your Zerodha Account</h4>
                    <a href="/" className="text-decoration-none lh-lg ">Login Credentials</a> <br />
                    <a href="/" className="text-decoration-none lh-lg ">Account Modification and Segment Addition</a> <br />
                    <a href="/" className="text-decoration-none lh-lg ">DP ID and bank details</a> <br />
                    <a href="/" className="text-decoration-none lh-lg ">Your Profile</a> <br />
                    <a href="/" className="text-decoration-none lh-lg ">Transfer and conversion of shares</a> <br />
                </div>

                <div className="col-4">
                    <h4> <i class="fa-solid fa-signal"></i> Your Zerodha Account</h4>
                    <a href="/" className="text-decoration-none lh-lg ">Margin/leverage, Product and Order types</a> <br />
                    <a href="/" className="text-decoration-none lh-lg ">Kite Web and Mobile</a> <br />
                    <a href="/" className="text-decoration-none lh-lg ">Trading FAQs</a> <br />
                    <a href="/" className="text-decoration-none lh-lg ">Corporate Actions</a> <br />
                    <a href="/" className="text-decoration-none lh-lg ">Sentinel</a> <br />
                     <a href="/" className="text-decoration-none lh-lg ">Kite API</a> <br />
                    <a href="/" className="text-decoration-none lh-lg ">Pi and other platform</a> <br />
                      <a href="/" className="text-decoration-none lh-lg ">Stockreports+</a> <br />
                    <a href="/" className="text-decoration-none lh-lg ">GTT</a> <br />
                </div>

            </div>


            <div className="row mt-5">
                <div className="col-4">
                    <h4> <i class="fa-solid fa-credit-card"></i>Funds</h4>
                    <a href="/" className="text-decoration-none lh-lg ">Adding Funds</a> <br />
                    <a href="/" className="text-decoration-none lh-lg ">Fund Withdrawal</a> <br />
                    <a href="/" className="text-decoration-none lh-lg ">eMandates</a> <br />
                    <a href="/" className="text-decoration-none lh-lg ">Adding Bank Accounts</a> <br />
                </div>

                <div className="col-4">
                    <h4> <i class="fa-solid fa-circle-notch"></i> Console</h4>
                    <a href="/" className="text-decoration-none lh-lg ">Reports</a> <br />
                    <a href="/" className="text-decoration-none lh-lg ">Ledger</a> <br />
                    <a href="/" className="text-decoration-none lh-lg ">Portfolio</a> <br />
                    <a href="/" className="text-decoration-none lh-lg ">60 Day Challenge</a> <br />
                    <a href="/" className="text-decoration-none lh-lg ">IPO</a> <br />
                    <a href="/" className="text-decoration-none lh-lg ">Referral Program</a> <br />

                </div>


                <div className="col-4">
                    <h4><i class="fa-regular fa-circle"></i>Coin</h4>
                    <a href="/" className="text-decoration-none lh-lg ">Understanding Mutual Funds</a> <br />
                    <a href="/" className="text-decoration-none lh-lg ">About Coin</a> <br />
                    <a href="/" className="text-decoration-none lh-lg ">Buying and Selling through Coin</a> <br />
                    <a href="/" className="text-decoration-none lh-lg ">Starting an SIP</a> <br />
                    <a href="/" className="text-decoration-none lh-lg ">Coin App</a> <br />
                    <a href="/" className="text-decoration-none lh-lg ">Moving to Coin</a> <br />
                    <a href="/" className="text-decoration-none lh-lg ">Government Securities</a> <br />

                </div>
            </div>
        </div>
     );
}

export default CreateTicket;